
// Drawer close
$('.drawer-header .close-btn, .drawer-back').off().click(function(e) {
  $(this).closest('.drawer').removeClass('active');
  handleFixedElements('show');
});
